import * as React from "react";
import { forwardRef } from "react";
const SvgCurrentSmall = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Property 1=Now, Size=S" }, /* @__PURE__ */ React.createElement("circle", { id: "Ellipse 381", cx: 7, cy: 7, r: 6, fill: "#1561D1", stroke: "#16326A", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("circle", { id: "Ellipse 382", cx: 7, cy: 7, r: 2.5, fill: "white" })));
const ForwardRef = forwardRef(SvgCurrentSmall);
export { ForwardRef as ReactComponent };
